import * as ApiWebServices from "../data/InternalWebServices/ApiWebServices";

global.configCache = null;

export async function init(host) {
  try {
    global.configCache = await ApiWebServices.fetchAppConfig();
    console.log("using (fresh) initialized appConfig", global.configCache);
  } catch (error) {
    console.error("fetchAppConfig failed!", error);
    return null;
  }
}

export async function updateAppConfig(newClientId) {
  try {
    await ApiWebServices.fetchStoreClientId(newClientId);
    global.configCache.clientId = newClientId;
  } catch (error) {
    console.error("updateAppConfig failed!", error);
  }
}

export function getBosIdentityServiceUrl() {
  return global.configCache.bosIdentityServiceUrl;
}

export function getBosWebGuiServiceUrl() {
  return global.configCache.bosWebGuiServiceUrl;
}

export function getBosFilesServiceUrl() {
  return global.configCache.bosFilesServiceUrl;
}

export function getUseIntegratedSecurity() {
  return global.configCache.useIntegratedSecurity;
}

export function getClientId() {
  return global.configCache.clientId;
}

export function getClientSecret() {
  return global.configCache.clientSecret;
}

export function getConfigDataGlobalDataSegmentId() {
  return global.configCache.configDataGlobalDatasegmentId;
}
